/**
 * IFRS textbook metadata + config
 */

const metadataChapters = [
  {
    chapt_num: 9,
    chapt_name: 'Accounts Receivable and Notes Receivable',
    subtitle: 'Chapter 9',
    hasAssessment: false,
    chunk: 'chapter9'
  }
];

export const chapters = metadataChapters.map((chapter) => ({
  chapter_id: chapter.chapt_num,
  chapt_num: chapter.chapt_num,
  chapt_name: `Chapter ${chapter.chapt_num}: ${chapter.chapt_name}`,
  subtitle: chapter.subtitle,
  hasAssessment: chapter.hasAssessment,
  chunk: chapter.chunk
}));

const getChapterByChunk = (chunk) => chapters.find((ch) => ch.chunk === chunk);

export const config = {
  id: 'IFRS',
  displayName: 'IFRS Accounting (8th Edition)',
  author: 'Tung Hua Book',
  coverImage: 'IFRS_Accounting_book_cover_image.jpg',
  route: 'IFRS',
  type: 'textbook',
  contentKey: 'IFRS',
  bookId: 'ifrs',
  usesExternalLinks: false,

  getTitleForChunk: function(chunk) {
    const chapter = getChapterByChunk(chunk);
    if (chapter?.chapt_name?.trim()) {
      return chapter.chapt_name.trim();
    }
    return 'Chapter';
  },

  getSubtitle: function(_fragmentRange, _level, _showCefrLevel, chunk) {
    const chapter = getChapterByChunk(chunk);
    if (chapter?.subtitle) {
      return chapter.subtitle;
    }
    return 'IFRS Textbook';
  }
};

const book = { config, chapters };

export default book;
